//Conversations
export const DASHBOARD = "#";

//Conversations
export const CONVERSATION_MESSAGES = "#";
export const CONVERSATION_DASHBOARD = "#dashboard";
export const CONVERSATION_HISTORY = "#history";
export const CONVERSATION_CONTACTS = "#contacts";

//Conversations
export const CAMPAGNE_DASHBOARD = "#";
export const CAMPAGNE_FOLLOW = "#cpg-follow";
export const CAMPAGNE_NEW = "#cpg-new";
export const CAMPAGNE_CONTACT = "#cpg-contact";
export const CAMPAGNE_TEMPLATE = "#cpg-template";
export const CAMPAGNE_NEW_TEMPLATE = "#cpg-new-template";
export const CAMPAGNE_MEDIA = "#cpg-media";

//CRM CLIENT
export const INVOICES = "#";
export const CLIENT_COMMANDS = "#client-commands";
export const STOCKS = "#stocks";
export const QUOTES = "#quotes";
export const PROFORMAT = "#proforma";
export const TRIPS = "#trips";
export const TICKETS = "#tickets";
export const RESERVATIONS = "#reservations";
export const EXPEDITIONS = "#expeditions";
export const PROVISIONAL_SLIPS = "#provisional-slips";

//FINANCE
export const FINANCES_DASHBOARD = "#";
export const FINANCES_REGISTRE_CAISSE = "#registre-caisse";
export const FINANCES_TRESORERIE = "#tresorerie";
export const FINANCES_COMMISSION_APPORTEUR = "#commission-apporteur";
export const FINANCES_RECONCILIATION = "#reconciliation";
export const FINANCES_TRANSACTIONS = "#transactions";
export const FINANCES_ETATS = "#etats";

//RESERVATION
// export const ROUTE_RESERVATION_RECHERCHE = '#recherche'
// export const ROUTE_RESERVATION_RESERVATION = "#reservations";
// export const ROUTE_RESERVATION_TICKET = "#tickets";
// export const ROUTE_RESERVATION_VOYAGE = "#voyages";
// export const ROUTE_RESERVATION_INCIDENT = "#incidents";
// export const ROUTE_RESERVATION_RECLAMATION = "#reclamations";
// export const ROUTE_RESERVATION_REMBOURSEMENT = "#remboursement";
export const RESERVATION_RECHERCHE = '#recherche'
export const RESERVATION_RESERVATION = "#reservations";
export const RESERVATION_TICKET = "#tickets";
export const RESERVATION_VOYAGE = "#voyages";
export const RESERVATION_INCIDENT = "#incidents";
export const RESERVATION_RECLAMATION = "#reclamations";
export const RESERVATION_REMBOURSEMENT = "#remboursement";

//EXPEDITION
export const EXPEDITION_RECHERCHE = '#recherche';
export const EXPEDITION_TRACKING = '#tracking';
export const EXPEDITION_INTERNATIONAL = '#international';
export const EXPEDITION_ENVOIS = '#international';
export const EXPEDITION_URBAIN = '#livraison-urbaine';
export const EXPEDITION_COMMERCE = '#commerce';
export const EXPEDITION_MARCHAND = '#marchand';
export const EXPEDITION_TICKET = '#international';
export const EXPEDITION_VOYAGE = '#voyages';
export const EXPEDITION_INCIDENT = '#incidents';
export const EXPEDITION_RECLAMATION = '#reclamations';
export const EXPEDITION_REMBOURSEMENT = '#remboursement';

//MARKETING
export const ROUTE_MARKETING_MESSAGE = "#message";
